export default __webpack_public_path__ + "static/media/nfo_icon.e9f42cb3.svg";